import csxl from 'clsx';

interface AccordionProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  isOpen: boolean;
}

export default function Accordion(props: AccordionProps) {
  const { children, isOpen, ...rest } = props;
  return (
    <div
      className={csxl('w-full toggle-container', isOpen && 'active')}
      {...rest}
    >
      <div className="overflow-hidden">{children}</div>
    </div>
  );
}
